import { type AxiosError } from "axios";
import { useCallback } from "react";

import {
    scheduleDraftsEndByJobIdPostV2,
    scheduleDraftsStartByJobIdPostV2,
} from "@btnet/services-btnet/handlers/schedule-drafts/schedule-drafts";

import { type ExceptionResponse } from "types/apiResponse/apiResponse";

import { showApixErrorMessage } from "utilities/api/apix-handler";

interface IUseDraftApiParams {
    jobId?: number;
}

export function useDraftApi({ jobId }: IUseDraftApiParams) {
    const startDraftMode = useCallback(async () => {
        if (!jobId) {
            return;
        }

        try {
            await scheduleDraftsStartByJobIdPostV2(jobId);
        } catch (error) {
            showApixErrorMessage(error as AxiosError<ExceptionResponse>);
        }
    }, [jobId]);

    const endDraftMode = useCallback(async () => {
        if (!jobId) {
            return;
        }

        try {
            await scheduleDraftsEndByJobIdPostV2(jobId);
        } catch (error) {
            showApixErrorMessage(error as AxiosError<ExceptionResponse>);
        }
    }, [jobId]);

    return {
        startDraftMode,
        endDraftMode,
    };
}
